export class Urls {
  static base_url = process.env.VUE_APP_URL;

  static user_baseUrl = process.env.VUE_APP_URL_USER;

  /// 我的积分
  static getPoints = "/v3/user/getPoints";
  ///抽奖 - 本期活动及奖品
  static lottery_curPhase = "/v3/lottery/curPhase";
  /// 当前幸运值可兑换的奖品
  static lottery_luckyValueAward = "/v3/lottery/luckyValueAward";
  /// 本期中奖者
  static lottery_curWinner = "/v3/lottery/curWinner";
  /// 当前幸运值
  static lottery_getLuckyValue = "/v3/lottery/getLuckyValue";
  /// 我的幸运列表
  static lottery_getMyLuckyCodes = "/v3/lottery/getMyLuckyCodes";
  /// 兑换幸运码
  static lottery_exchange = "/v3/lottery/luckyCode/exchange";
  /// 本期幸运码
  static lottery_luckyCodes = "/v3/lottery/luckyCodes";
  /// 历期中奖名单
  static lottery_phases = "/v3/lottery/phases";
  /// 奖品兑换
  static lottery_order = "/v3/lottery/order";
  /// 是否中奖
  static lottery_isWinner = "/v3/lottery/isWinner";

  /// -------------------------wx--------------------------
  /// 微信公众号JSSDK配置
  static getJssdkConfig = "/v3/getJssdkConfig";
  /// 获取微信用户openid
  static getWecahtOpenID = "/wechat/mp/open_id";
  /// 微信openid
  static getwxOpenid = "/open/wechat/getWechatOpenid";
  static getwxUserInfo = "/open/wechat/getWechatUserInfo";

  // --------------------------user------------------------
  /// 获取用户信息
  static user_info = "/v3/user/getAccessToken";

  // --------------------------点击按钮抽奖活动--------------------------------
  // 微信授权 通过code 获取openid
  static adkb_activity_wxopen = "/v3/activity/singles/wxopen";
  // 点击按钮
  static adkb_activity_batter = "/v3/activity/singles/batter";
  // 活动展示
  static adkb_activity_data = "/v3/activity/singles/index";
  /// 分享
  static adkb_activity_share = "/v3/activity/singles/share";
  // 抽奖
  static adkb_activity_lottery = "/v3/activity/singles/lottery";
  /// 领取奖品-填写收获地址
  static adkb_activity_address = "/v3/activity/singles/takeReward";
  // 查看红包
  static adkb_activity_view = "/v3/activity/singles/view";
  // 统计京东的pv
  static adkb_accessRecord = "/v3/activity/singles/accessRecord";


  // --------------------------点击按钮抽奖活动--------------------------------
  // 微信授权 通过code 获取openid
  static activity_newyear_wxopen = "/v3/activity/newyear/wxopen";
  // 活动展示
  static activity_newyear_index = "/v3/activity/newyear/index";
  // 抽字
  static activity_newyear_word = "/v3/activity/newyear/luckyDraw";
  /// 领取奖品-填写收获地址
  static activity_newyear_address = "/v3/activity/newyear/takeReward";
  // 查看奖品
  static activity_newyear_gift = "/v3/activity/newyear/userReward";
  // 统计
  static activity_newyear_statistics = "/v3/activity/newyear/accessRecord";

  // --------------------------七夕抽奖活动--------------------------------

  // 微信授权 通过code 获取openid
  static activity_tanabata_wxopen = "/v3/activity/wxopen";
  // 获取活动状态
  static activity_tanabata_status = "/v3/activity/getActivityState";
  // 分享获取抽奖机会
  static activity_tanabata_share = "/v3/activity/chanceFromShare";
  // 访问记录
  static activity_tanabata_access = "/v3/activity/accessRecord";
  // 问题列表
  static activity_tanabata_question = "/v3/activity/getQuestionList";
  // 提交答题结果
  static activity_tanabata_submit = "/v3/activity/saveAnswer";
  // 获取用户剩余抽奖次数
  static activity_tanabata_change = "/v3/activity/availableChances";
  // 抽奖
  static activity_tanabata_lottery = "/v3/activity/luckyDraw";
  // 领取奖品
  static activity_tanabata_reward = "/v3/activity/takeReward";
}
